<template>
  <component
    v-if="isEnabled"
    :is="component"
    :query="query"
    :value="items"
    :is-loading="Boolean(promise)"
    v-bind="$attrs"
    v-on="$listeners"
    @refetch="fetch"
  >
    <template #top>
      <slot name="top" />
    </template>
    <template #bottom>
      <div v-if="promise" class="fade row between px-2 py-1">
        <span>{{ $t('loading', { resource: null }) }}...</span>
        <FontAwesomeIcon :icon="['fal', 'spinner-third']" spin />
      </div>
      <slot name="bottom" />
    </template>
  </component>
</template>

<script>
import fetch from '@/fetch'
import { ObjectToDotNotation } from '@/utils'

import Dropdown from './Dropdown'
import List from './List'

export default {
  props: {
    placement: {
      type: String,
      required: true,
    },
    query: Object,
    type: {
      type: String,
      default: 'dropdown',
      enum: ['dropdown', 'list'],
    },
  },
  provide() {
    return {
      getQuery: () => this.query,
      getPlacement: () => this.placement,
    }
  },
  data() {
    return {
      promise: null,
      items: [],
    }
  },
  computed: {
    isEnabled() {
      return Boolean(
        this.items.length ||
          (this.$slots.bottom && this.$slots.bottom.some(e => e.tag)) ||
          (this.$slots.top && this.$slots.top.some(e => e.tag)) ||
          (this.type === 'list' && this.promise),
      )
    },
    component() {
      switch (this.type) {
        case 'dropdown':
          return Dropdown
        case 'list':
          return List
      }
    },
    qs() {
      let p = new URLSearchParams()
      Object.entries(ObjectToDotNotation(this.query || {})).forEach(([key, value]) => {
        if (value === undefined) return
        if (value instanceof Array) return value.forEach(v => p.append(key, v))
        return p.append(key, value)
      })

      return p
    },
  },
  methods: {
    fetch(dry = false) {
      let qs = this.qs
      if (dry) qs.append('dry', 'true')
      this.promise = fetch(`/api/action/${this.placement}?${qs.toString()}`, {
        headers: {
          'Cache-Control': 'nocache',
          'kvass-client-route-name': this.$route.name,
        },
      })
        .then(res => res.json())
        .then(items => {
          this.items = items
          this.promise = null
        })
    },
  },
  created() {
    this.fetch(this.type === 'dropdown')

    this.$bus.$on('actions:refetch', placement => {
      if (placement && this.placement !== placement) return
      this.fetch()
    })
  },
}
</script>
